import type { getStatusInput } from "@/api/custom_types";
import { createReactQueryKeys } from "@/utils/react-query";

interface KeyTypes {
	useGetStatus: getStatusInput;
}

const STATUS_SERVICE_KEYS = createReactQueryKeys<KeyTypes>("status", [
	"useGetStatus",
]);

export { STATUS_SERVICE_KEYS };
